var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { observable, action, computed } from "mobx";
import { LoadState, SearchResultsState, SearchQueryLength, PersonalizedViewState } from "../../../data";
import { DeviceDetect } from "sb-resp-utils";
export class SearchState {
    constructor(options) {
        this.minQueryLength = SearchQueryLength.ThreeSymbolSearch;
        this.delay = 200;
        this.maxCountSearchResultsForShowPersonalizedResults = 4;
        this.query = "";
        this.hasFocus = false;
        this.isDesktop = DeviceDetect.getInstance().isDesktop;
        this.searchFocusHandler = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.hasFocus) {
                yield this.provider.updateRecents();
            }
            this.hasFocus = true;
        });
        this.clickHandler = (e) => {
            const target = e.target;
            if (!target.closest(".rj-bet-search-form")) {
                this.clearAndClose();
            }
        };
        this.closeClickHandler = () => {
            this.clearQuery();
            this.provider.navHandler.goBack(false);
        };
        this.clearAndClose = () => {
            this.hasFocus = false;
            this.clearQuery();
        };
        this.provider = options.provider;
        this.dict = options.dict;
        this.config = options.cms;
        this.setQuery = this.setQuery.bind(this);
        this.clearRecents = this.clearRecents.bind(this);
        this.setSearchBarInput = this.setSearchBarInput.bind(this);
        this.setSearchBar = this.setSearchBar.bind(this);
        this.minQueryLength = this.setMinQueryLength(this.config, options.currentLangCode);
    }
    activate() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.provider.activate();
        });
    }
    deactivate() {
        this.provider.deactivate();
    }
    setSearchBarInput(inputElement) {
        this.searchBarInput = inputElement;
    }
    setSearchBar(divElement) {
        this.searchBar = divElement;
    }
    setQuery(query) {
        this.query = query;
        clearTimeout(this.delayTimeout);
        if (this.query.length >= this.minQueryLength) {
            this.delayTimeout = setTimeout(this.provider.getData, this.delay, this.query);
        }
        (query.length === 0 && (this.clearQuery()));
    }
    clearQuery() {
        this.query = "";
        this.provider.searchResults = [];
        this.provider.loadState = LoadState.NotLoading;
        this.searchBarInput && this.searchBarInput.focus();
    }
    clearRecents() {
        this.provider.clearRecents();
    }
    get searchResultsState() {
        switch (this.provider.loadState) {
            case LoadState.NotLoading: return SearchResultsState.Empty;
            case LoadState.Loading: return SearchResultsState.Loading;
            case LoadState.Loaded: return this.searchResults.length ? SearchResultsState.HasResults : SearchResultsState.NoResults;
        }
    }
    get formattedSearchResultsLength() {
        return this.searchResults.length > 0 ? `(${this.searchResults.length})` : "";
    }
    get wrapperHeight() {
        var _a, _b;
        let panelsLeftHolderHeight = ((_a = document.getElementById("panels-left-holder")) === null || _a === void 0 ? void 0 : _a.clientHeight) || 0;
        let searchBarHeight = ((_b = this.searchBar) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().height) || 0;
        return this.isDesktop ? `${panelsLeftHolderHeight - searchBarHeight}px` : "100%";
    }
    get hasSearchResultsSection() {
        return this.searchResultsState !== SearchResultsState.Empty;
    }
    get hasRecentSection() {
        return (!this.isDesktop || this.hasFocus) && this.query === "" && this.recentResults.length > 0;
    }
    get hasPersonalizedSection() {
        return (!this.isDesktop || this.hasFocus) && this.searchResultsState !== SearchResultsState.Loading && this.personalizedResultsState !== PersonalizedViewState.Empty;
    }
    get hasSearchResultContainer() {
        return this.hasSearchResultsSection || this.hasRecentSection || this.hasPersonalizedSection;
    }
    get searchResults() {
        return this.provider.searchResults;
    }
    get personalizedResults() {
        return this.provider.personalizedResults;
    }
    get recentResults() {
        return this.provider.recents
            .filter(item => item.entity !== undefined)
            .sort((a, b) => b.timestamp - a.timestamp)
            .map(item => item.entity);
    }
    get personalizedResultsState() {
        if (this.provider.personalizedLoadState === LoadState.NotLoading) {
            return PersonalizedViewState.Empty;
        }
        if (this.provider.personalizedLoadState === LoadState.Loading) {
            return PersonalizedViewState.Loader;
        }
        if (!!this.personalizedResults.length && this.searchResults.length < this.maxCountSearchResultsForShowPersonalizedResults) {
            return PersonalizedViewState.Events;
        }
        return PersonalizedViewState.Empty;
    }
    setMinQueryLength(cmsConfig, curLangCode) {
        if (cmsConfig.LanguagesFor1SymbolSearch.indexOf(curLangCode) >= 0) {
            return SearchQueryLength.OneSymbolSearch;
        }
        if (cmsConfig.LanguagesFor2SymbolSearch.indexOf(curLangCode) >= 0) {
            return SearchQueryLength.TwoSymbolSearch;
        }
        return SearchQueryLength.ThreeSymbolSearch;
    }
}
__decorate([
    observable,
    __metadata("design:type", String)
], SearchState.prototype, "query", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], SearchState.prototype, "hasFocus", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SearchState.prototype, "clearQuery", null);
__decorate([
    computed,
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [])
], SearchState.prototype, "searchResultsState", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], SearchState.prototype, "hasSearchResultsSection", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], SearchState.prototype, "hasRecentSection", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], SearchState.prototype, "hasPersonalizedSection", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], SearchState.prototype, "hasSearchResultContainer", null);
__decorate([
    computed,
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [])
], SearchState.prototype, "recentResults", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], SearchState.prototype, "personalizedResultsState", null);
//# sourceMappingURL=SearchState.js.map